import { isIFrame } from '@/azure/application';

export const sendPostMessage = (message: any, parentDomain: string | null): void => {
  if (parentDomain && isIFrame()) {
    window.parent.postMessage(message, parentDomain);
  }
};
